import { PreviewConstant } from "./PreviewConstant";
import { PreviewUtil } from "./PreviewUtil";
export class TitleService {
    constructor(brainClient) {
        this.brainClient = brainClient;
    }
    async generateTitle(input) {
        const params = {
            identifier_type: "file",
            identifier_value: "brain_studios_saas_app_title_generation.model",
            stream: false,
            variables: { input },
        };
        const res = await this.brainClient.openAi.completionsGenerationV2(params);
        const responseTitle = PreviewUtil.getTitleFromResponse(res);
        const defaultTitle = responseTitle.title || PreviewConstant.webAppDefaultTitle;
        // bsf-6211 将 subtitle 默认为空了
        const defaultSubTitle = responseTitle.subTitle || "";
        return { title: defaultTitle, subTitle: defaultSubTitle };
    }
}
